module.exports = __webpack_public_path__ + "media/images/fanclub/kv-curtain-e927ce893d0a5b292b34a88e00c1ac7d.png";